import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkshopJobcardPreServiceChecksComponent } from './workshop-jobcard-pre-service-checks/workshop-jobcard-pre-service-checks.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { AppConfig } from 'src/app/app.config';
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';

@Component({
  selector: 'app-workshop-jobcard-checklists',
  templateUrl: './workshop-jobcard-checklists.component.html',
  styleUrls: ['./workshop-jobcard-checklists.component.scss']
})
export class WorkshopJobcardChecklistsComponent {

  @Input() jobcard: any;
  @Input() preServiceChecklist: any[] = [];
  @Output() jobcardChange = new EventEmitter<any>();


  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private appConfig: AppConfig,
    public workshopJobcardCreateService: WorkshopJobcardCreateService
  ) {

  }

  openPreChecklist() {
    const modalRef = this.modalService.open(WorkshopJobcardPreServiceChecksComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.preServiceChecklist = this.preServiceChecklist;

    modalRef.result.then(
      (result) => {
        this.preServiceChecklist = result;
        this.jobcardChange.emit({...result});
      },
      (onrejected) => {

      },
    );
  }



}
